import { render, staticRenderFns } from "./ChampionshipEventCard.vue?vue&type=template&id=36847533&scoped=true&"
import script from "./ChampionshipEventCard.vue?vue&type=script&lang=js&"
export * from "./ChampionshipEventCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipEventCard.vue?vue&type=style&index=0&id=36847533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36847533",
  null
  
)

export default component.exports